import LanguageSupportModal from './LanguageSupportModal';

export default LanguageSupportModal;
